import React from "react";
import Heroicon from "../Heroicon";

function QuickActions({ firstPodcast, podcastData }) {
  return (
    <>
      <section className="flex flex-wrap gap-6 p-5 mt-6 bg-white rounded-lg shadow">
        <Heroicon
          icon="o-lock-closed"
          style="w-10 h-10 p-2 text-purple-800 bg-purple-300 rounded-lg shrink-0"
        />
        <div className="flex-1">
          <h3 className="font-sans text-lg font-semibold text-gray-700">
            Planning on making a{" "}
            <span className="text-purple-600">private podcast</span>?
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Set this podcast to private so that your RSS feed can only be
            accessed by those with the right feed url and access.
          </p>
          {firstPodcast ? (
            <form action="/podcast/onboarding/quick-action">
              <input
                type="hidden"
                name="podcast"
                value={podcastData.podcast_id}
              />
              <input type="hidden" name="quickAction" value="visibility" />
              <button
                type="submit"
                className="flex items-center gap-1 mt-2 btn-solid btn-primary w-max"
              >
                Manage Visibility
                <Heroicon icon="o-arrow-right" style="w-4 h-4" />
              </button>
            </form>
          ) : (
            <a
              href={`/podcasts/${podcastData.podcast_id}/edit/distribution/visibility`}
              className="flex items-center gap-1 mt-2 btn-solid btn-primary w-max"
            >
              Manage Visibility
              <Heroicon icon="o-arrow-right" style="w-4 h-4" />
            </a>
          )}
        </div>
      </section>
      <section className="flex flex-wrap gap-6 p-5 mt-6 mb-20 bg-white rounded-lg shadow">
        <Heroicon
          icon="o-currency-dollar"
          style="w-10 h-10 p-2 text-purple-800 bg-purple-300 rounded-lg shrink-0"
        />
        <div className="flex-1">
          <h3 className="font-sans text-lg font-semibold text-gray-700">
            Planning on <span className="text-purple-600">monetizing</span> your
            podcast?
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Explore our Castos Ads and Donations options to start monetizing
            your podcasts, we make it easy to get started.
          </p>
          {firstPodcast ? (
            <form action="/podcast/onboarding/quick-action">
              <input
                type="hidden"
                name="podcast"
                value={podcastData.podcast_id}
              />
              <input type="hidden" name="quickAction" value="monetization" />
              <button
                type="submit"
                className="flex items-center gap-1 mt-2 btn-solid btn-primary w-max"
              >
                Manage Monetizing
                <Heroicon icon="o-arrow-right" style="w-4 h-4" />
              </button>
            </form>
          ) : (
            <a
              href={`/podcasts/${podcastData.podcast_id}/edit/monetization/ads/settings`}
              className="flex items-center gap-1 mt-2 btn-solid btn-primary w-max"
            >
              Manage Monetizing
              <Heroicon icon="o-arrow-right" style="w-4 h-4" />
            </a>
          )}
        </div>
      </section>
    </>
  );
}

export default QuickActions;
